export const getSelection = state => state.selection
